<!-- 
Dialog for performing a provider task that doesn't require any input.
-->
<template>
  <dialog-base
    v-model="show"
    :levy-collection-id="levyCollectionId"
    :provider-id="providerId"
    :task="task"
    user-guide-topic="levy-collection-providers"
    user-guide-section="running-a-levy-collection-provider-task"
    @run="run"
    @hide="hide"
  />
</template>

<script>
import DialogBase from "./DialogBase.vue";
import mixins from "./mixins";

export default {
  components: { DialogBase },
  mixins: [mixins]
};
</script>
